<template>
    <p class="mt-8 text-sm leading-loose text-center text-gray-600 lg:text-base lg:leading-loose">
        Join over 1,000,000 people who saved up to 80%<br class="hidden sm:block"> on lawyer fees with Unbundled Legal
        Help
    </p>
</template>

<script>
export default {};
</script>
